export const DIVIDAS_THRESHOLD_TEMPO_MS_PADRAO = 5000;

/**
 * Tempo (ms) da janela de sincronização antes de exibir a lista de dívidas.
 * Única fonte de verdade para o threshold do sync e a duração da tela de loading.
 */
export function getDividasThresholdTempoMs(): number {
  return Number(appSettings.VUE_APP_DIVIDAS_THRESHOLD_TEMPO_MS) || DIVIDAS_THRESHOLD_TEMPO_MS_PADRAO;
}
